import { render, staticRenderFns } from "./GraphicDesign.vue?vue&type=template&id=8816b0e4&"
import script from "./GraphicDesign.vue?vue&type=script&lang=js&"
export * from "./GraphicDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports